<div class="smooth-scrolling" (click)="clickOrder()">
    <div class="order-detail">
        <div class="order-title">
            <div class="back-arrow">
                <a (click)="backToOrderList()"><img src="assets/images/back-arrow.svg" alt="arrow" /></a>
            </div>
            <div class="order-text">
                <h4>Orders details</h4>
            </div>
        </div>
        <div class="order-box-detail">
            <div class="o-number">
                <label>Order Number</label>
                <span>{{orderDetail?.order_number}}</span>
            </div>
            <div class="o-number place-on">
                <label>Place On</label>
                <span>{{showDate(orderDetail?.order_date)}}</span>
            </div>
            <div class="o-number total">
                <label>Total</label>
                <span>₹{{orderDetail?.order_amount}}</span>
            </div>
        </div>
        <div class="shipping-detail">
            <h4>Shipping Address</h4>
            <div class="shipping-name">{{orderDetail?.customer_detail?.first_name}}</div>
            <address>{{orderDetail?.user_address}}</address>
        </div>
        <div *ngIf="orderDetail && orderDetail.product_detail && orderDetail.product_detail.length > 0">
            <div class="shipment-detail" *ngFor="let product of orderDetail.product_detail; let i = index;">
                <div class="shipment-content">
                    <span class="shipment-item">Shipment 0 0f {{product?.product_qty}}</span>
                    <div class="package-delivered">Your package will be delivered within</div>
                    <div class="package-delivered-date">5-6 working days</div>
                </div>
                <div class="o-detail">
                    <div class="o-left-detail">
                        <div class="order-img">
                            <span >
                                <img src="{{product.imageList && product.imageList.length > 0 && product.imageList[0].path ? product.imageList[0].path : 'assets/images/default-product.png'}}" alt="image" />
                            </span>
                        </div>
                        <div class="order-content-detail">
                            <span>{{product?.brand}}</span>
                            <h4>{{product?.name}}</h4>
                            <div class="qty-label">Qty</div>
                            <div class="qty-item">{{product?.product_qty}}</div>
                        </div>
                    </div>
                    <div class="o-right-btn">
                        <div class="total-line-through" *ngIf="product?.discountAppliedAmount && !showDiscountOnTotal">₹{{calculateIndividualTotal(product?.product_qty
                            || 1, product?.your_price)}}</div>
                        <div class="total-price"  *ngIf="product?.discountAppliedAmount && product?.discountType == 'fix' && !showDiscountOnTotal">₹{{product?.discountAppliedAmount}}</div>
                        <div class="total-price"  *ngIf="product?.discountAppliedAmount && product?.discountType == 'percentage' && !showDiscountOnTotal">₹{{product?.discountAppliedAmount}}</div>

                        <div class="total-price"  *ngIf="!product?.discountAppliedAmount && !showDiscountOnTotal">₹{{calculateIndividualTotal(product?.product_qty
                            || 1, product?.your_price)}}</div>
                            
                            <div class="total-price" *ngIf="showDiscountOnTotal">
                                <span>₹{{calculateIndividualTotal(product?.product_qty || 1,
                                    product?.your_price)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cancel-and-track-order">
            <ul>
                <li *ngIf="orderDetail?.order_status == 'delivered'">
                    <a href="https://forms.gle/BF71Yd6H1HwRN1787" target="_blank" class="return-btn">return & Exchange</a>
                </li>
                <li *ngIf="orderDetail?.order_status != 'Cancelled' && orderDetail?.order_status != 'cancel'"><a data-bs-toggle="modal" data-bs-target="#confirmation" (click)="cancelOrder(orderDetail)" class="cancel-border">cancel order</a></li>

                <li *ngIf="orderDetail?.order_status == 'Cancelled' || orderDetail?.order_status == 'cancel'"><a  class="cancel-border">Cancelled</a></li>
            </ul>
        </div> 
        <div class="need-help-link">
            <a (click)="redirectToNeedHelp()">
                Need Help?
                <img src="assets/images/order-right-arrow.png" alt="arrow" />
            </a>
        </div>
        <div class="payment-method-detail">
            <h4>Payment Detail</h4>
            <div class="p-detail">
                <label>Payment method</label>
                <span>{{orderDetail?.cod == true? 'COD': 'ONLINE'}}</span>
            </div>
            <div class="p-detail">
                <label>Subtotal (Inclusive Tax)</label>
                <span>₹{{subTotalInclusiveTax}}</span>
            </div>
            <div class="p-detail" *ngIf="orderDetail?.total_discount_amount > 0">
                <label>Discount</label>
                <span> <small>(-)</small> ₹{{orderDetail?.total_discount_amount}}</span>
            </div>
            <div class="p-detail">
                <label>Shipping Charges</label>
                <span>₹{{orderDetail?.shipping_charge}}</span>
            </div>
            <div class="p-detail p-total">
                <label>Total:</label>
                <span>₹{{totalAmount}}</span>
            </div>
        </div>
        <div class="total-saving">
            <label>Total Savings:</label>
            <span>₹{{totalSavings}}</span>
        </div>
    </div>
    
</div>

<div class="modal fade modal-add-contact" id="confirmation" tabindex="-1" role="dialog">
    <app-confirmation [id]="id" [deleteType]="deleteType"
      (saveClick)="getOrderDetail(orderId)"></app-confirmation>
  </div>